"use client";

// PASTE #563: keep third-party analytics OFF the card payment page. The card
// fields are NMI iframes (PCI SAQ A), and SAQ A expects the page hosting them
// to load no scripts beyond what payment needs. /checkout/card is entered with
// a full navigation, so on that document GA simply never mounts.

import { usePathname } from "next/navigation";

export const ANALYTICS_FREE_PREFIXES = ["/checkout/card"];

export function GaRouteGate({ children }: { children: React.ReactNode }) {
  const pathname = usePathname() ?? "";
  if (ANALYTICS_FREE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    return null;
  }
  return <>{children}</>;
}
